package com.klantenstop.web.data.models.dto.requests.address

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ValidateAddressDto(
    @SerialName("street_name")
    val streetName: String,
    @SerialName("street_number")
    val streetNumber: String,
    @SerialName("zip_code")
    val zipCode: String,
    val city: String,
    val country: String
)
